import { FormSchema } from '../form-definition';
import { createContext } from 'react';

export const SchemaContext = createContext<FormSchema>({
  fields: null,
  form: null,
  schema: null,
});
